module.exports = __webpack_public_path__ + "img/farzana-christopher-121.5fa2370c.jpg";